import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import AddFavourite from "../../utility/js/addFav";
import documentService from "./document-upload-service";
import EncryptUtility from "../../utility/js/encrypt-utility";
import Utility from "../../../shared/utility.js";
import moment from "moment";
export default {
  data: () => ({
    name: "DocumentMastersAccountDetails",
    userId: EncryptUtility.localStorageDecrypt("userID"),
    route: "",
    mainPage: "",
    subPage: "",
    subPageUrl: "",
    appPageName: "",
    pageName: "",
    backSlash: true,
    backSlashParent: true,
    refresh: true,
    totalRecords: 0,
    searchFilterTrainingRecords: "",
    selectedDocumentType: 0,
    documentTypeList: [],
    selectedPersonnel: 0,
    personnelList: [],
    selectedDocumentStatus: 0,
    documentStatusList: [],
    exportDisable: true,
    trainingReportItems: [],
    pageCount: 0,
    page: 1,
    maxStartDate: new Date().toISOString().split("T")[0],
    minEndDate: new Date(new Date().getTime() - 86400000).toISOString().split("T")[0],
    maxEndDate: new Date(new Date().getTime()).toISOString().split("T")[0],
    sDate: "",
    eDate: "",
    showStartDate: true,
    showEndDate: true,
    startDate: false,
    endDate: false,
    headersTrainingReport: [
      { text: "Document No", align: "start", value: "document_number", class: "primary customwhite--text" },
      { text: "Account Name", value: "account_name", class: "primary customwhite--text" },
      { text: "Title", value: "title", class: "primary customwhite--text" },
      { text: "Employee", value: "Employee", class: "primary customwhite--text" },
      { text: "Document Type", value: "type_name", class: "primary customwhite--text" },
      { text: "Publish Date", value: "assigned_date", class: "primary customwhite--text" },
      { text: "Training Completed", value: "end_date", class: "primary customwhite--text" },
    ],
    json_fields: {
      "Document Number": "document_number",
      "Account Name": "account_name",
      Title: "title",
      Employee: "Employee",
      "Document Type": "type_name",
      "Published Date": "assigned_date",
      "Training Completed Date": "end_date",
    },
  }),
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    this.loadDropdowns();
    this.getTrainingReportData(1);
  },
  computed: {
    computedDateFormattedMomentjs() {
      return this.sDate ? moment(this.sDate).format("MM/DD/YYYY") : moment(new Date().getTime() - 86400000).format("MM/DD/YYYY");
    },
    computedEndDateFormattedMomentjs() {
      return this.eDate ? moment(this.eDate).format("MM/DD/YYYY") : moment(new Date()).format("MM/DD/YYYY");
    },
  },
  methods: {
    //Reset function
    resetFunction() {
      this.showStartDate = false;
      this.showEndDate = false;
      this.$nextTick(() => {
        this.showStartDate = true;
        this.sDate = null;
        this.showEndDate = true;
        this.eDate = null;
      });
      this.totalRecords = 0;
      this.searchFilterTrainingRecords = "";
      this.selectedDocumentType = 0;
      this.documentTypeList = [];
      this.selectedPersonnel = 0;
      this.personnelList = [];
      this.selectedDocumentStatus = 0;
      this.documentStatusList = [];
      this.exportDisable = true;
      this.trainingReportItems = [];
      this.pageCount = 0;
      this.page = 1;
      this.loadDropdowns();
      this.getTrainingReportData(1);
    },
    async getTrainingReportData(page) {
      !this.sDate ? (this.sDate = new Date(new Date().getTime() - 86400000).toISOString().substr(0, 10)) : "";
      let obj = {
        start_date: Utility.inputDateFormat(this.computedDateFormattedMomentjs, "00:00:00"),
        end_date: Utility.inputDateFormat(this.computedEndDateFormattedMomentjs, "23:59:59"),
        page_number: page,
        page_size: 10,
        account_key: 1,
        search_string: this.searchFilterTrainingRecords,
        status_key: parseInt(this.selectedDocumentStatus),
        type_key: parseInt(this.selectedDocumentType),
        applicable_personnel_key: parseInt(this.selectedPersonnel),
        sort_column: "document_id",
        sort_direction: "DESC",
      };
      let data = await documentService.documentTrainingReport("post", obj, false);
      if (data.message !== "NA" && data.length !== 0) {
        const newArr = data.map((obj) => {
          return {
            ...obj,
            assigned_date: Utility.displayDateFormat(obj.assigned_date),
            end_date: Utility.displayDateFormat(obj.end_date),
          };
        });
        this.trainingReportItems = newArr;
        this.totalRecords = data[0]?.total_records;
        this.pageCount = data[0]?.total_pages;
        this.exportDisable = false;
      } else {
        this.trainingReportItems = [];
        this.totalRecords = 0;
        this.pageCount = 0;
        this.exportDisable = true;
      }
    },
    // set end Date
    setEndDate() {
      let minEndDate = new Date(this.sDate);
      this.minEndDate = new Date(minEndDate.getTime() + 0).toISOString().substr(0, 10);
      let maxSDate = new Date(this.maxStartDate);
      this.maxEndDate = new Date(maxSDate.getTime() + 0).toISOString().substr(0, 10);
    },
    async loadDropdowns() {
      let masterObj = {
        pass: 0,
        user_id: parseInt(this.userId),
      };
      let masterData = await documentService.documentLoadMasters("post", masterObj, false);
      if (masterData.message !== "NA") {
        this.documentTypeList = masterData.document_type;
        this.personnelList = masterData.applicable_personnel;
      }
    },
    async exportToExcel() {
      if (this.totalRecords <= 15000) {
        this.startDownload();
        let obj = {
          start_date: Utility.inputDateFormat(this.computedDateFormattedMomentjs, "00:00:00"),
          end_date: Utility.inputDateFormat(this.computedEndDateFormattedMomentjs, "23:59:59"),
          page_number: this.page,
          page_size: 10,
          account_key: 1,
          search_string: this.searchFilterTrainingRecords,
          status_key: parseInt(this.selectedDocumentStatus),
          type_key: parseInt(this.selectedDocumentType),
          applicable_personnel_key: parseInt(this.selectedPersonnel),
          sort_column: "document_id",
          sort_direction: "DESC",
        };
        const response = await this.axios.post("du/document_training_report", obj);
        let responseData = response.data.body;
        const formattedData = responseData.map((obj) => ({
          ...obj,
          assigned_date: Utility.displayDateFormat(obj.assigned_date),
          end_date: Utility.displayDateFormat(obj.end_date),
        }));
        Utility.exportExcel(formattedData, this.json_fields, Utility.excelNewFileName("Document_Training_Report"), "Document Training Report");
        this.finishDownload();
      } else {
        this.finishDownload();
        return true;
      }
    },
    //Get Search data
    getSearchData() {
      if (this.searchFilterTrainingRecords.length > 3) {
        this.getTrainingReportData(1);
      }
    },
    //Start the Loader when excel process starts
    startDownload() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
    },
    // end the Loader when the process is completed
    finishDownload() {
      let LoaderDialog = {
        visible: false,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
    },
    //To add or remove Favourite issue
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
  },
  components: {
    breadcrumbComp,
  },
};
